import { Grid, Typography } from '@mui/material';
import { t } from 'i18next';
import ControlledTextField from 'src/shared/components/form/controlledTextField';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { useGlobals } from 'src/shared/contexts/appContext';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import ControlledTextEditor from 'src/shared/components/form/controlledTextEditor';
import { AssociationAndDistrictSelectEvent } from 'src/shared/components/organisms/associationAndDistrictSelectEvent';
import { useEventContext } from 'src/shared/contexts/eventContext';
import { EventImageUpload } from './eventImageUpload';

export const EventFormStepDescription = () => {
  const { currentUser } = useGlobals();

  const { event } = useEventContext();

  ConsoleHelper.log('EventFormStepDescription hasevent', event);

  return (
    <GridWrapper>
      <Grid item xs={12}>
        <Typography variant='body1' sx={{ fontWeight: 600, mb: -1 }}>
          {t('event:description')}
        </Typography>
      </Grid>
      <Grid item xs={12} lg={8}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <ControlledTextField
              name='name'
              required
              label={t('event:formFields.name')}
              inputProps={{ maxLength: 100 }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <ControlledTextEditor name='description' rows={12} eventMode />
          </Grid>
          <Grid item xs={12}>
            <GridWrapper>
              <AssociationAndDistrictSelectEvent
                useGridLayout
                hideDistrict={currentUser?.districts.length === 0}
                associationFormFieldName='association'
                districtFormFieldName='district'
                // associationCallback={(val) => ConsoleHelper.log(val)} // Not used
                // districtCallback={(val) => ConsoleHelper.log(val)}  // Not used
              />
            </GridWrapper>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} lg={4} sx={{ display: 'flex', width: '100%', alignItems: 'stretch', '& > *': { flex: 1 } }}>
        <EventImageUpload />
      </Grid>
    </GridWrapper>
  );
};
